import { FC } from 'react';
import getFormItem from '../hooks/getFormItem';
import { EditableCellProps } from '../interface';

const EditableCell: FC<EditableCellProps> = props => {
  const {
    record,
    editable,
    children,
    rowIndex,
    formItemProps,
    disabled,
    disabledRenderKey,
    form,
    optionsKey,
    defaultPropsKey,
    enumCodeKey,
    ...restProps
  } = props;
  return (
    <td {...restProps}>
      {editable
        ? getFormItem(record, {
            ...formItemProps,
            disabled,
            form,
            optionsKey,
            defaultPropsKey,
            enumCodeKey,
          })
        : children}
    </td>
  );
};

export default EditableCell;
